<script>
    import Carousel from './Carousel.svelte';
    import Videos from './Videos.svelte';
    export let events;
    let resetIndex = 0;
    console.log('past events: ',events);
    let eventSelected = events[0];
</script>

<h1>Past Broadcasts</h1>
<Videos videos={eventSelected.video} index={resetIndex} />
<Carousel on:eventSelected={(event)=> {eventSelected = event.detail.event; resetIndex=0}} {events}/>